module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fake_player_button", [["span",{"class":"play bg-color-2-trans-70 text-color-1"},[["i",{"class":"icon-au_play"}],["textNode",{"text":" "}],["span",{"class":"txt"},[["textNode",{"text":"play welcome video"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/player/fakeButton.tpl
// module id = 66
// module chunks = 4